module.exports = __webpack_public_path__ + "img/cxgdlogo.a56d3548.png";